import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { noop } from 'helpers/GlobalHelper';
import Style from 'components/Account/SharedStyles/SharedStyles.module.scss';
import Header from '../Header';
import Menu from './Menu';

const AccountMain = ({
  favoritesManager,
  firstName,
  headerProps,
  toggleAccountMain,
  toggleChangePassword,
  toggleEditAccount,
  toggleManageFavorites,
  toggleParentalControls,
  toggleSignOut,
}) => {
  const {
    profile: { menu },
  } = window.ExternalConfig;
  const favorites = _.get(favoritesManager, 'favoritesDetails', []);
  const hasFavorites = favorites.length > 0;
  const menuProps = {
    menu,
    firstName,
    toggleEditAccount,
    toggleAccountMain,
    toggleChangePassword,
    toggleManageFavorites,
    toggleSignOut,
    toggleParentalControls,
    hasFavorites,
  };

  return (
    <main className={Style.AccountContainer}>
      <Header {...headerProps} />
      <div className={Style.InnerContainer}>
        <Menu {...menuProps} />
      </div>
    </main>
  );
};

export default AccountMain;

AccountMain.defaultProps = {
  favoritesManager: {},
  firstName: '',
  headerProps: {},
  toggleAccountMain: noop,
  toggleChangePassword: noop,
  toggleCreatePassword: noop,
  toggleEditAccount: noop,
  toggleManageFavorites: noop,
  toggleParentalControls: noop,
  toggleSignOut: noop,
};

AccountMain.propTypes = {
  favoritesManager: PropTypes.shape({}),
  firstName: PropTypes.string,
  headerProps: PropTypes.shape({}),
  toggleAccountMain: PropTypes.func,
  toggleChangePassword: PropTypes.func,
  toggleCreatePassword: PropTypes.func,
  toggleEditAccount: PropTypes.func,
  toggleManageFavorites: PropTypes.func,
  toggleParentalControls: PropTypes.func,
  toggleSignOut: PropTypes.func,
};
